import BaseItem, { Rarity } from './base_item';

export default class Shield extends BaseItem {
    constructor(x, y) {
        super(x, y, "items", "shield_i01.png");
        this.animations.add('idle', ['shield_i01.png','shield_i02.png','shield_i03.png'], 3, true).play();
    }

    //this is width/height of collision box (attached to bottom)
    static get width() { return 15;}
    static get height() { return 8;}

    static get mass() { return 5;}
    static get electronic() { return true; }
    static get rarity() { return Rarity.RARE; }

    static get type() { return 'shield'}
    static get label() { return 'shield generator'}
    static get description() { return `Shield generator. It smells like high-speed collision safety with a hint of lavender.`}
}


// WEBPACK FOOTER //
// ./src/objects/items/shield.js